import {
    CssBaseline,
    StyledEngineProvider,
    ThemeProvider,
} from "@mui/material";
import React from "react";
import { useLocation } from "react-router";
import AppTheme from "Theme/AppTheme";
import AuthPage from "./AuthPage";

function Saml() {
    // const { search } = useLocation();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const m = params.get("m");
    // const { m } = qs.parse(search);
    const message = atob(m ?? "");

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={AppTheme}>
                <CssBaseline />
                <AuthPage title={message} shouldShowLinks></AuthPage>
            </ThemeProvider>
        </StyledEngineProvider>
    );
}

export default Saml;
